import { CheckCircle, X } from 'lucide-react'

interface TicketSuccessBannerProps {
  onClose: () => void
}

export const TicketSuccessBanner = ({ onClose }: TicketSuccessBannerProps) => {
  return (
    <div className="bg-green-50 border border-green-200 rounded-2xl p-4 flex items-start gap-3">
      <CheckCircle className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" />
      <div className="flex-1">
        <h4 className="text-sm font-semibold text-green-900">Ticket sent to support!</h4>
        <p className="text-sm text-green-700 mt-1">
          Your issue has been reported successfully and our support team will review it shortly.
        </p>
      </div>
      <button
        onClick={onClose}
        className="text-green-600 hover:text-green-800 transition-colors flex-shrink-0"
        aria-label="Close"
      >
        <X className="w-5 h-5" />
      </button>
    </div>
  )
}
